export default __webpack_public_path__ + "static/media/W25P2005_04.917b3bdd.png";